export default "__VITE_ASSET__C9ed_ct8__"